import {ShapeCommand} from '../commands.template';

export class ActivityReorderCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public prepareData() {
    // this.reverseData = {
    //   mxKey: this.object.mxKey,
    //   position: this.object.previousPosition
    // };
    return this;
  }

  public execute() {
    super.execute();

    if (!this.firstAction) {
      const model = this.services.editorRegistrySvc.getGraph().model;
      const cell = model.getCell(this.object.mxKey);

      cell.skipUndo = true;
      model.add(cell.parent, cell, this.object.position);
    }

    this.firstAction = false;

    return this.sendChanges(this.object);
  }

  public reverse() {
    super.reverse();
    const model = this.services.editorRegistrySvc.getGraph().model;
    const cell = model.getCell(this.object.mxKey);

    cell.skipUndo = true;
    model.add(cell.parent, cell, this.object.previousPosition);

    return this.sendChanges({
      mxKey: this.object.mxKey,
      position: this.object.previousPosition
    });
  }

  private sendChanges(data) {
    const action: any = {
      reorderActivity: {
        mxKey: Number(data.mxKey),
        position: data.position
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(data.mxKey)
      .comp.instance.setupFromJson();
  }
}
